import { Dimensions, Platform } from 'react-native'

export const isPortrait = () => {
  const dim = Platform.OS === 'web' ? Dimensions.get('window') : Dimensions.get('screen');
  return dim.height > 100 ? dim.height >= dim.width : true
}